import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiHalfsmile3dSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_72)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 1.333C3.167 1.333 1.334 3.167 1.334 16S3.167 30.667 16 30.667 30.667 28.833 30.667 16 28.833 1.333 16 1.333m-1.792 20.779c-.24-.255-.341-.524-.341-.779h-2.4c0 .947.394 1.785.991 2.422.86.914 2.157 1.445 3.542 1.445 1.386 0 2.683-.53 3.542-1.445.598-.637.991-1.475.991-2.422h-2.4c0 .255-.101.524-.34.779-.358.38-.997.688-1.793.688s-1.434-.307-1.792-.688m4.126-9.445c0-1.167.583-2.334 2.333-2.334S23 11.5 23 12.667C23 13.833 22.417 15 20.667 15s-2.334-1.167-2.334-2.333m-7-2.334C9.584 10.333 9 11.5 9 12.667 9 13.833 9.584 15 11.334 15s2.333-1.167 2.333-2.333-.583-2.334-2.333-2.334"
                    fill={`url(#${_uniqueId}paint0_radial_8745_72)`}
                    suppressHydrationWarning
                />
                <path
                    d="M13.867 21.333c0 .255.102.524.341.779.357.38.996.688 1.792.688s1.435-.307 1.792-.688c.24-.255.341-.524.341-.779h2.4c0 .947-.393 1.785-.991 2.422-.859.914-2.157 1.445-3.542 1.445s-2.683-.53-3.542-1.445c-.597-.637-.991-1.475-.991-2.422z"
                    fill={`url(#${_uniqueId}paint1_radial_8745_72)`}
                    suppressHydrationWarning
                />
                <path
                    d="M9 12.667c0-1.167.584-2.334 2.334-2.334s2.333 1.167 2.333 2.334c0 1.166-.583 2.333-2.333 2.333S9 13.833 9 12.667"
                    fill={`url(#${_uniqueId}paint2_radial_8745_72)`}
                    suppressHydrationWarning
                />
                <path
                    d="M20.667 10.333c-1.75 0-2.334 1.167-2.334 2.334 0 1.166.584 2.333 2.334 2.333S23 13.833 23 12.667s-.583-2.334-2.333-2.334"
                    fill={`url(#${_uniqueId}paint3_radial_8745_72)`}
                    suppressHydrationWarning
                />
            </g>
            <path
                d="M13.867 21.333c0 .255.102.524.34.779.358.38.997.688 1.793.688s1.435-.307 1.792-.688c.24-.255.341-.524.341-.779h2.4c0 .947-.394 1.785-.991 2.422-.86.914-2.157 1.445-3.542 1.445s-2.683-.53-3.542-1.445c-.597-.637-.991-1.475-.991-2.422z"
                fill="#79610C"
            />
            <path
                d="M9 12.667c0-1.167.583-2.334 2.333-2.334s2.334 1.167 2.334 2.334c0 1.166-.584 2.333-2.334 2.333S9 13.833 9 12.667"
                fill="#79610C"
            />
            <path
                d="M20.667 10.333c-1.75 0-2.334 1.167-2.334 2.334 0 1.166.584 2.333 2.334 2.333S23 13.833 23 12.667s-.583-2.334-2.333-2.334"
                fill="#79610C"
            />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_72`}
                    x={1.333}
                    y={-3.667}
                    width={34.333}
                    height={34.333}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={5} dy={-5} />
                    <feGaussianBlur stdDeviation={5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_72" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_72`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_72`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_72`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_72`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiHalfsmile3dSize32Glyph.displayName = 'EmojiHalfsmile3dSize32Glyph';
